import React from 'react';
import { Hydrator } from '@thd-olt-component-react/hydrator';
/* eslint-disable max-len */
import { PersonalizedHomeServices as PersonalizedHomeServicesComponent } from '@thd-olt-component-react/personalized-home-services';
import { Card } from '@thd-olt-component-react/core-ui';

import classnames from 'classnames/bind';
import componentStyles from './components.module.scss';

const styles = classnames.bind(componentStyles);

export function CustomRenderedPersonalizedHomeServices({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,
}) {
  return function PersonalizedHomeServices() {
    return (
      <Hydrator
        id="personalizedHomeServices-php-hydrator"
        className={styles('u-height-100')}
        scrollBuffer={SCROLL_BUFFER}
        delay={HOMEPAGE_DELAY_STANDARD}
        placeholder={PLACEHOLDER}
      >
        <Card>
          <PersonalizedHomeServicesComponent />
        </Card>
      </Hydrator>
    );
  };
}
